import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";


const art = `
           *************
         *****************
        *******************
 #################################

            &&&     &&&
   &&&&&&                  //////
 &&&&&&&&&&&&       ///////////////
&&&&& &&&&&&&&&&   ////////////////
 &&&&&&& &&&&&&&  /////////////////
 &&&&&&&&&&/&&&&&////// //////////
  &&&&&&&&&&& &&&//// ////////////
    &&&&&&&&&&&&&///////////////
        &&&&&&&&&//////////
`;

const stylesMap = {
  '*': 'color:#FF8C00',
  '#': 'color:#888888',
  '&': 'color:#00A699',
  '/': 'color:#3FB1D9',
  ' ': '',
};
let fmt = '';
const styleArgs = [];
art.split('\n').forEach((line, i) => {
  const parts = line.match(/(@+|\*+|#+|&+|\/+|\s+)/g) || [];
  
  fmt += parts.map(_ => '%c' + _).join('');
  

  if (i < art.split('\n').length - 1) fmt += '\n';
  

  parts.forEach(seg => {
    styleArgs.push(stylesMap[seg[0]] || '');
  });
});

console.log(fmt, ...styleArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();




